import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'next/navigation';

// A simple utility to convert a React Router-like path to a regex
export function pathToRegex(path: string): RegExp {
  const escapedPath = path.replace(/[.+?^${}()|[\]\\]/g, '\\$&');

  // Replace :param with a regex group that matches anything until the next '/' or end
  const regexString = escapedPath.replace(/:([a-zA-Z0-9_]+)/g, '([^/]+)');
  return new RegExp(`^${regexString}(/)?$`);
}
export default function useGetMatchPath() {
  const $ = _c(2);
  const pathname = usePathname();
  let t0;
  if ($[0] !== pathname) {
    t0 = path => Boolean(pathname.match(pathToRegex(path)));
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}